module.exports = __webpack_public_path__ + "static/arkadius-fa02171fe16ceb067ff8c0a1de1e296b.png";